import React from 'react';
import { Route } from 'react-router-dom'
import UnAuthHeader from '../components//header/UnAuthHeader';

/* Login Layout */
const LoginLayout = ({ children, ...rest }) => {
  return (
    <React.Fragment>
      <UnAuthHeader />
      <div className="ta--login-layout ta--flex ta--justify-center ta--align-center">
        {children}
      </div>
    </React.Fragment>
  )
}

/* Route wrapper */
export const LoginLayoutRoute = ({ component: Component, ...rest }) => {
  return (
    <Route {...rest} render={matchProps => (
      <LoginLayout>
        <Component {...matchProps} />
      </LoginLayout>
    )} />
  )
};


// WEBPACK FOOTER //
// ./src/layouts/LoginLayout.js